import {
  type ListControllerResult,
  type RaRecord,
  useListContext,
} from "react-admin";

type FilterValues = Record<string, unknown>;

export type TypedListContext<
  RecordType extends RaRecord = RaRecord,
  Filter extends FilterValues = FilterValues,
> = Omit<ListControllerResult<RecordType>, "filterValues"> & {
  filterValues: Filter;
};

export const useTypedListContext = <
  RecordType extends RaRecord = RaRecord,
  Filter extends FilterValues = FilterValues,
>(): TypedListContext<RecordType, Filter> => useListContext<RecordType>();
